import { render, staticRenderFns } from "./SharedProjects.vue?vue&type=template&id=1cf6465f"
import script from "./SharedProjects.vue?vue&type=script&lang=js"
export * from "./SharedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports